// Generated by purs version 0.15.15
import * as Control_Applicative from "../Control.Applicative/index.js";
import * as Data_Eq from "../Data.Eq/index.js";
import * as Data_Ord from "../Data.Ord/index.js";
import * as Data_Show from "../Data.Show/index.js";
import * as Ouroboros_TsBridge_Branding from "../Ouroboros.TsBridge.Branding/index.js";
import * as Simple_JSON from "../Simple.JSON/index.js";
import * as TsBridge_Monad from "../TsBridge.Monad/index.js";
var pure = /* #__PURE__ */ Control_Applicative.pure(TsBridge_Monad.applicativeTsBridgeM);
var IsoTimestamp = function (x) {
    return x;
};
var tsBridgeIsoTimestamp = {
    tsBridge: function (v) {
        return pure(Ouroboros_TsBridge_Branding.brandedStringType("IsoTimestamp")("__brandIsoTimestamp"));
    }
};
var writeIsoTimestamp = Simple_JSON.writeForeignString;
var unwrap = function (v) {
    return v;
};
var showIsoTimestamp = Data_Show.showString;
var readIsoTimestamp = Simple_JSON.readString;
var ordIsoTimestamp = Data_Ord.ordString;
var newtypeIsoTimestamp = {
    Coercible0: function () {
        return undefined;
    }
};
var makeIsoTimestamp = IsoTimestamp;
var eqIsoTimestamp = Data_Eq.eqString;
export {
    IsoTimestamp,
    makeIsoTimestamp,
    unwrap,
    newtypeIsoTimestamp,
    eqIsoTimestamp,
    ordIsoTimestamp,
    showIsoTimestamp,
    readIsoTimestamp,
    writeIsoTimestamp,
    tsBridgeIsoTimestamp
};
//# sourceMappingURL=index.js.map
